import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthLayout } from "../components/AuthLayout";
import { Spinner } from "../components/Loading";
import { request } from "../lib/api";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      const result = await request<{ message: string }>("/api/auth/forgot-password", {
        method: "POST",
        body: JSON.stringify({ email })
      });
      setMessage(result.message);
    } catch (submissionError) {
      setError(submissionError instanceof Error ? submissionError.message : "Request failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthLayout subtitle="Recover your LimitX account">
      <h2>Reset your password</h2>
      <p className="subheading">Enter your account email and we&apos;ll send a secure reset link.</p>
      {message ? <div className="alert alert-success">{message}</div> : null}
      {error ? <div className="alert alert-error">{error}</div> : null}
      <form className="form-stack" onSubmit={submit}>
        <div className="field">
          <label htmlFor="resetEmail">Email</label>
          <input
            id="resetEmail"
            className="input-field"
            type="email"
            autoComplete="email"
            placeholder="your@email.com"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
        </div>
        <button className="btn btn-primary btn-block" disabled={loading}>
          {loading ? <Spinner small /> : null}
          {loading ? "Sending..." : "Send Reset Link"}
        </button>
      </form>
      <p className="auth-switch">
        <Link to="/login" className="text-link">
          Back to sign in
        </Link>
      </p>
    </AuthLayout>
  );
}
